/*
 * Yurls Shop — winkelwagen-drawer.
 *
 * Hoort bij sections/yurls-cart-drawer.liquid. Dit script rekent niets uit:
 * na elke wijziging haalt het de sectie opnieuw op bij Shopify en zet het die
 * neer. Bedragen, gratis-markering en kortingsblok zijn dus altijd wat Shopify
 * zelf berekend heeft.
 *
 * ==========================================================================
 * WANNEER HIJ OPENT
 * ==========================================================================
 *
 *   • na elk geslaagd verzoek naar /cart/add, van welke knop ook — de
 *     koopknop, de meescrollende koopbalk, of iets wat er later bij komt.
 *     Dat gaat op dezelfde manier als in snippets/cart-toast.liquid: fetch
 *     wordt onderschept en het antwoord met een kopie gelezen, zodat de code
 *     die het verzoek deed het origineel ongelezen terugkrijgt.
 *   • bij een klik op de winkelwagenknop in de header.
 *
 * Op elke schermbreedte, behalve op de winkelwagenpagina zelf. Onder de
 * 640 px is het een paneel van onderen (bottom sheet); dat regelt de CSS. Het
 * script doet daar één ding extra: naar beneden slepen aan handvat of kop
 * sluit het paneel. Op elke breedte laat een verloop boven de voet zien dat
 * er nog meer onder zit zolang je verder kunt scrollen.
 *
 * Verzoeken van de drawer zelf dragen de kop X-Yurls-Drawer. Daaraan herkent
 * de onderschepping ze: een boekje toevoegen vanuit de carrousel moet de
 * drawer bijwerken, niet opnieuw openen.
 *
 * ==========================================================================
 * VERWIJDEREN
 * ==========================================================================
 *
 * Er zijn geen aantalknoppen meer, alleen het kruisje op het omslagje. Net
 * als op de winkelwagenpagina (assets/yurls-cart-lines.js) kent een rij de
 * sleutels van alle regels waarover Shopify dat ene boekje verdeeld heeft;
 * verwijderen zet ze allemaal op nul, in één verzoek. Op regelnummer of
 * variantnummer gaat het mis zodra de bundelkorting een boekje over meerdere
 * regels verdeelt.
 *
 * ==========================================================================
 * DE WISSELENDE REGEL ONDER DE KNOP
 * ==========================================================================
 *
 * De drie punten ("Print zo vaak je wilt …") staan op één plek; om de
 * 3,5 seconde komt de volgende. Alleen zolang de drawer open is, niet terwijl
 * je er met de muis op staat, en niet bij "minder beweging" — dan blijft de
 * eerste staan. Schermlezers lezen alle drie gewoon één keer.
 *
 * ==========================================================================
 * ALS DE SECTIE NIET TERUGKOMT
 * ==========================================================================
 *
 * In een voorbeeldweergave kan Shopify de sectie van het gepubliceerde thema
 * terugsturen (zie assets/yurls-cart-upsell.js). Heeft dat thema deze drawer
 * nog niet, dan komt er niets bruikbaars terug. Dan valt het script terug op
 * wat altijd werkt: na toevoegen naar de winkelwagenpagina, na een wijziging
 * de pagina herladen.
 */

(function () {
  /*
   * De onderschepping staat buiten het element en gebeurt maar één keer. In de
   * theme-editor wordt de sectie bij elke wijziging opnieuw neergezet; zonder
   * deze bewaking zou fetch dan steeds een laag dieper ingepakt worden.
   */
  if (window.__yurlsDrawerFetch) return;
  window.__yurlsDrawerFetch = true;

  var original = window.fetch;

  function isOwn(init) {
    var headers = init && init.headers;
    if (!headers) return false;
    if (typeof headers.get === 'function') return !!headers.get('X-Yurls-Drawer');
    return !!headers['X-Yurls-Drawer'];
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = original.apply(this, arguments);

    if (url.indexOf('/cart/add') !== -1 && !isOwn(init)) {
      result
        .then(function (response) {
          if (!response.ok) return;
          return response
            .clone()
            .json()
            .then(function (data) {
              if (data && data.status) return;
              document.dispatchEvent(new CustomEvent('yurls:cart-added', { detail: data }));
            });
        })
        .catch(function () {});
    }

    return result;
  };
})();

if (!customElements.get('yurls-cart-drawer')) {
  customElements.define(
    'yurls-cart-drawer',
    class YurlsCartDrawer extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.panel = this.querySelector('[data-ycd-panel]');
        this.live = this.querySelector('[data-ycd-live]');
        this.sheet = window.matchMedia('(max-width: 639px)');
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.busy = false;
        this.focusFallback = null;
        this.drag = null;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onAdded = this.onAdded.bind(this);
        this.onTrackScroll = this.updateArrows.bind(this);
        this.onScroll = this.updateFade.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDragMove = this.onDragMove.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('pointerdown', this.onDragStart);
        this.addEventListener('pointermove', this.onDragMove);
        this.addEventListener('pointerup', this.onDragEnd);
        this.addEventListener('pointercancel', this.onDragEnd);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('yurls:cart-added', this.onAdded);
        window.addEventListener('resize', this.onResize);

        this.bindTrack();

        // In de theme-editor openen zodra je de sectie aanklikt, zodat je ziet
        // wat je aanpast.
        if (window.Shopify && window.Shopify.designMode) {
          this.onSelect = (event) => {
            if (event.detail && event.detail.sectionId === this.sectionId) this.open();
          };
          this.onDeselect = (event) => {
            if (event.detail && event.detail.sectionId === this.sectionId) this.close();
          };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('yurls:cart-added', this.onAdded);
        window.removeEventListener('resize', this.onResize);
        this.stopUsps();
        if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
        document.documentElement.classList.remove('ycd-lock');
      }

      /* ------------------------------------------------------------------
         Wanneer de drawer meedoet
         ------------------------------------------------------------------ */

      enabled() {
        var cartPath = this.dataset.cartUrl || '/cart';
        return window.location.pathname.indexOf(cartPath) !== 0;
      }

      root() {
        var routes = window.Shopify && window.Shopify.routes;
        return (routes && routes.root) || '/';
      }

      onAdded() {
        if (!this.enabled()) return;
        var trigger = document.activeElement;

        this.refresh().then((ok) => {
          if (ok) {
            this.open(trigger);
          } else {
            window.location.href = this.dataset.cartUrl || '/cart';
          }
        });
      }

      onDocumentClick(event) {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var link = event.target.closest('a.y-header__cart');
        if (!link || !this.enabled()) return;

        event.preventDefault();
        this.open(link);
        this.refresh();
      }

      /* ------------------------------------------------------------------
         Openen en sluiten
         ------------------------------------------------------------------ */

      open(trigger) {
        if (this.hasAttribute('open')) {
          this.updateArrows();
          return;
        }

        this.trigger = trigger && trigger !== document.body ? trigger : null;

        var root = document.documentElement;
        root.style.setProperty('--ycd-scrollbar', window.innerWidth - root.clientWidth + 'px');
        root.classList.add('ycd-lock');

        this.setAttribute('open', '');
        // Eerst tonen, dan pas de klasse die hem laat inschuiven; anders is er
        // geen beginstand om vanaf te schuiven.
        void this.offsetWidth;
        this.classList.add('is-open');

        // De focus op het venster zelf, niet op de sluitknop: anders staat er
        // meteen een ring om de ×. Schermlezers lezen de titel voor (via
        // aria-labelledby) en Tab gaat van hier naar de eerste knop.
        this.panel.focus({ preventScroll: true });

        this.updateArrows();
        requestAnimationFrame(() => this.updateFade());
        this.startUsps();
        this.track('cart_drawer_open');
      }

      close() {
        if (!this.hasAttribute('open')) return;

        this.classList.remove('is-open');
        this.stopUsps();

        var finish = () => {
          if (this.classList.contains('is-open')) return;
          this.removeAttribute('open');
          document.documentElement.classList.remove('ycd-lock');
        };
        setTimeout(finish, this.calm.matches ? 0 : 240);

        // Terug naar de knop die de drawer opende. Is die er niet (meer), dan
        // naar de winkelwagenknop in de header, zodat de focus niet achterblijft
        // in een drawer die niet meer te zien is.
        var back = this.trigger && document.contains(this.trigger) ? this.trigger : document.querySelector('a.y-header__cart');
        if (back) {
          back.focus({ preventScroll: true });
        } else if (this.contains(document.activeElement)) {
          document.activeElement.blur();
        }
        this.trigger = null;
      }

      /* ------------------------------------------------------------------
         Slepen om te sluiten (alleen de bottom sheet)

         Aan het handvat of de kop naar beneden trekken laat het paneel
         meebewegen. Ver genoeg (100 px) of snel genoeg losgelaten: dicht.
         Anders veert het terug. De sluitknop in de kop blijft gewoon een knop.
         ------------------------------------------------------------------ */

      onDragStart(event) {
        if (!this.sheet.matches || !this.classList.contains('is-open')) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (!event.target.closest('[data-ycd-drag], .ycd__head')) return;
        if (event.target.closest('button, a')) return;

        this.drag = { id: event.pointerId, y: event.clientY, t: Date.now(), dy: 0 };
        this.panel.style.transition = 'none';
        try {
          this.panel.setPointerCapture(event.pointerId);
        } catch (error) {}
      }

      onDragMove(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        this.drag.dy = Math.max(0, event.clientY - this.drag.y);
        this.panel.style.transform = 'translateY(' + this.drag.dy + 'px)';
      }

      onDragEnd(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        var dy = this.drag.dy;
        var speed = dy / Math.max(1, Date.now() - this.drag.t);
        this.drag = null;

        // Beide in één keer terugzetten: de overgang loopt dan vanaf waar
        // het paneel nu hangt, naar dicht of terug naar open.
        this.panel.style.transition = '';
        this.panel.style.transform = '';

        if (event.type !== 'pointercancel' && (dy > 100 || (dy > 30 && speed > 0.5))) this.close();
      }

      /* ------------------------------------------------------------------
         Verloop boven de voet. Aan zolang er onder de rand nog iets zit.
         ------------------------------------------------------------------ */

      updateFade() {
        var scroller = this.querySelector('[data-ycd-scroll]');
        var more = !!scroller && scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight > 2;
        this.classList.toggle('has-more', more);
      }

      onResize() {
        if (!this.hasAttribute('open')) return;
        this.updateArrows();
        this.updateFade();
      }

      /* ------------------------------------------------------------------
         De wisselende regel onder de knop. Zie de toelichting bovenaan.
         ------------------------------------------------------------------ */

      startUsps() {
        this.stopUsps();
        if (this.calm.matches || !this.hasAttribute('open')) return;

        this.uspTimer = setInterval(() => {
          var list = this.querySelector('[data-ycd-usps]');
          if (!list || document.hidden || list.matches(':hover')) return;

          var items = list.querySelectorAll('.ycd-usps__item');
          if (items.length < 2) return;

          var current = list.querySelector('.ycd-usps__item.is-active');
          var index = Array.prototype.indexOf.call(items, current);
          if (current) current.classList.remove('is-active');
          items[(index + 1) % items.length].classList.add('is-active');
        }, 3500);
      }

      stopUsps() {
        if (this.uspTimer) clearInterval(this.uspTimer);
        this.uspTimer = null;
      }

      /* ------------------------------------------------------------------
         Klikken en toetsen
         ------------------------------------------------------------------ */

      onClick(event) {
        var target = event.target;

        var closer = target.closest('[data-ycd-close]');
        if (closer) {
          event.preventDefault();
          if (closer.hasAttribute('data-ycd-continue')) this.track('cart_drawer_continue_shopping');
          this.close();
          return;
        }

        var remove = target.closest('[data-ycd-remove]');
        if (remove) {
          this.changeQty(remove.closest('[data-variant]'), 0);
          return;
        }

        var add = target.closest('[data-ycd-add]');
        if (add) {
          this.addRecommendation(add);
          return;
        }

        if (target.closest('[data-ycd-prev]')) {
          this.slide(-1);
          return;
        }

        if (target.closest('[data-ycd-next]')) {
          this.slide(1);
          return;
        }

        if (target.closest('[data-ycd-checkout]')) {
          this.track('cart_drawer_checkout_click');
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        // De focus blijft binnen de drawer zolang hij open is.
        var items = this.focusables();
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;

        if (event.shiftKey && (active === first || active === this.panel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      }

      focusables() {
        var selector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.prototype.filter.call(this.panel.querySelectorAll(selector), function (el) {
          return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null;
        });
      }

      /* ------------------------------------------------------------------
         Aantallen en toevoegen
         ------------------------------------------------------------------ */

      changeQty(row, quantity) {
        if (!row || this.busy) return;

        var keys = (row.dataset.keys || '').split(',').filter(Boolean);
        if (!keys.length) return;
        if (quantity < 0) quantity = 0;

        // Alles op de eerste sleutel, de rest leeg. Zie de toelichting bovenaan.
        var updates = {};
        keys.forEach(function (key, index) {
          updates[key] = index === 0 ? quantity : 0;
        });

        // Verdwijnt de rij, dan de focus naar de rij die op zijn plek komt.
        var rows = Array.prototype.slice.call(this.querySelectorAll('.ycd-line'));
        var index = rows.indexOf(row);
        this.focusFallback = () => {
          var fresh = this.querySelectorAll('.ycd-line');
          var next = fresh[Math.min(index, fresh.length - 1)];
          return next ? next.querySelector('[data-ycd-remove]') : null;
        };

        this.post(
          'cart/update.js',
          JSON.stringify({
            updates: updates,
            sections: [this.sectionId, 'cart-icon-bubble'],
            sections_url: window.location.pathname
          }),
          row
        );
      }

      addRecommendation(button) {
        if (this.busy || button.getAttribute('aria-busy') === 'true') return;

        var cards = Array.prototype.slice.call(this.querySelectorAll('.ycd-rec'));
        var index = cards.indexOf(button.closest('.ycd-rec'));

        // Het kaartje verdwijnt na het toevoegen; de focus gaat naar het
        // kaartje dat op zijn plek schuift.
        this.focusFallback = () => {
          var fresh = this.querySelectorAll('.ycd-rec__add');
          return fresh[Math.min(index, fresh.length - 1)] || null;
        };

        button.setAttribute('aria-busy', 'true');
        this.track('cart_drawer_recommendation_add', { variantId: button.dataset.variant });

        var body = new FormData();
        body.append('id', button.dataset.variant);
        body.append('quantity', '1');
        body.append('sections', this.sectionId + ',cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        this.post('cart/add.js', body, null).then(function () {
          if (button.isConnected) button.removeAttribute('aria-busy');
        });
      }

      post(path, body, row) {
        this.busy = true;
        if (row) row.setAttribute('data-busy', '');

        var headers = {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Yurls-Drawer': '1'
        };
        if (typeof body === 'string') headers['Content-Type'] = 'application/json';

        return fetch(this.root() + path, { method: 'POST', headers: headers, body: body })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then((result) => {
            if (!result.ok || result.data.status) {
              throw new Error(result.data.description || result.data.message || '');
            }
            if (!this.render(result.data.sections)) window.location.reload();
          })
          .catch((error) => {
            var message = (error && error.message) || 'Dit lukte niet. Probeer het nog eens.';
            var slot = row && row.isConnected ? row.querySelector('[data-ycd-error]') : null;
            if (slot) {
              slot.textContent = message;
              slot.hidden = false;
            }
            this.say(message);
          })
          .finally(() => {
            this.busy = false;
            this.focusFallback = null;
            if (row && row.isConnected) row.removeAttribute('data-busy');
          });
      }

      /* ------------------------------------------------------------------
         Opnieuw neerzetten
         ------------------------------------------------------------------ */

      refresh() {
        var url = this.root() + '?sections=' + encodeURIComponent(this.sectionId + ',cart-icon-bubble');
        return fetch(url, { headers: { Accept: 'application/json', 'X-Yurls-Drawer': '1' } })
          .then(function (response) {
            return response.json();
          })
          .then((sections) => this.render(sections))
          .catch(function () {
            return false;
          });
      }

      render(sections) {
        var html = sections && sections[this.sectionId];
        if (!html) return false;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ycd-content]');
        var current = this.querySelector('[data-ycd-content]');
        if (!fresh || !current) return false;

        // Wat bewaard moet blijven: hoever je gescrold was, in de lijst en in
        // de carrousel, en welke knop de focus had.
        var scroller = current.querySelector('[data-ycd-scroll]');
        var scrollTop = scroller ? scroller.scrollTop : 0;
        var track = current.querySelector('[data-ycd-track]');
        var trackLeft = track ? track.scrollLeft : 0;

        var active = document.activeElement;
        var hadFocus = active && this.contains(active);
        var keyed = hadFocus ? active.closest('[data-focus-key]') : null;
        var focusKey = keyed ? keyed.dataset.focusKey : null;

        current.innerHTML = fresh.innerHTML;

        var newScroller = current.querySelector('[data-ycd-scroll]');
        if (newScroller) newScroller.scrollTop = scrollTop;

        var newTrack = current.querySelector('[data-ycd-track]');
        if (newTrack) {
          newTrack.style.scrollBehavior = 'auto';
          newTrack.scrollLeft = trackLeft;
          newTrack.style.scrollBehavior = '';
        }

        this.bindTrack();
        if (hadFocus) this.restoreFocus(focusKey);
        this.updateBubble(sections['cart-icon-bubble']);

        var announce = current.querySelector('[data-ycd-announce]');
        if (announce) this.say(announce.textContent.trim());

        return true;
      }

      restoreFocus(key) {
        var target = key ? this.querySelector('[data-focus-key="' + key + '"]') : null;
        if (!target && this.focusFallback) target = this.focusFallback();
        if (!target) target = this.querySelector('[data-ycd-close-button]');
        if (target) target.focus({ preventScroll: true });
      }

      /* Het aantal in de winkelwagenknop in de header, zoals product-form.js dat doet. */
      updateBubble(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById('shopify-section-cart-icon-bubble');
        var target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      }

      /* Voorlezen via het vaste statusvak; eerst leeg, anders herhaalt een
         schermlezer dezelfde tekst niet. */
      say(text) {
        if (!this.live || !text) return;
        this.live.textContent = '';
        setTimeout(() => {
          this.live.textContent = text;
        }, 60);
      }

      /* ------------------------------------------------------------------
         Carrousel
         ------------------------------------------------------------------ */

      /* Na elke nieuwe inhoud opnieuw: de oude elementen zijn vervangen. */
      bindTrack() {
        var scroller = this.querySelector('[data-ycd-scroll]');
        if (scroller) scroller.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateFade();

        var track = this.querySelector('[data-ycd-track]');
        if (!track) return;
        track.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.updateArrows();
      }

      slide(direction) {
        var track = this.querySelector('[data-ycd-track]');
        if (!track) return;

        var button = this.querySelector(direction < 0 ? '[data-ycd-prev]' : '[data-ycd-next]');
        if (button && button.getAttribute('aria-disabled') === 'true') return;

        var card = track.querySelector('.ycd-rec');
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 12;
        var step = card ? card.getBoundingClientRect().width + gap : 162;

        track.scrollBy({ left: direction * step, behavior: this.calm.matches ? 'auto' : 'smooth' });
      }

      /* Pijlen blijven altijd staan; aan het begin of einde gaan ze uit. */
      updateArrows() {
        var track = this.querySelector('[data-ycd-track]');
        var prev = this.querySelector('[data-ycd-prev]');
        var next = this.querySelector('[data-ycd-next]');
        if (!track || !prev || !next) return;

        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      /* ------------------------------------------------------------------
         Meten
         ------------------------------------------------------------------ */

      /*
       * Via de klantgebeurtenissen van Shopify (Instellingen > Klantgebeurtenissen).
       * Een pixel daar kan erop abonneren met analytics.subscribe('cart_drawer_open', …).
       */
      track(name, data) {
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish(name, data || {});
          }
        } catch (error) {}
      }
    }
  );
}
